import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'antd';
import Icon from '../components/ui-components/Icon';
import WarningIcon from '../assets/images/warning-icon.svg';

export const useInfoPopup = () => {
	const { t } = useTranslation();

	const InfoContent = useCallback(
		(content: string, icon?: string | null) => {
			return (
				<div className="flex flex-col font-sans font-normal text-sm">
					<div className="flex flex-col items-center">
						<div className="w-24 h-20 my-4">
							<Icon src={icon ? icon : WarningIcon} className="w-full h-full" />
						</div>
						<div className="text-center my-2">{t(content)}</div>
					</div>
				</div>
			);
		},
		[t]
	);

	const InfoFooter = useCallback(
		<T,>(action: () => Promise<T> | void) => {
			return (
				<div className="flex w-full gap-4 mt-4">
					<Button
						type="default"
						className="flex-1 h-9 px-4 py-2 font-sans font-bold text-sm bg-primary-blue text-white rounded-lg"
						onClick={() => {
							Modal.destroyAll();
							void action();
						}}
					>
						{t('ok')}
					</Button>
				</div>
			);
		},
		[t]
	);

	const infoPopUpAction = useCallback(
		<T extends void>(
			title: string,
			content: string,
			action: () => Promise<T> | void,
			icon?: string | null
		) => {
			return Modal.info({
				className: 'max-w-md',
				centered: true,
				okText: t('ok'),
				icon: null,
				title: (
					<div className="text-center font-sans font-bold text-lg">
						{t(title)}
					</div>
				),
				content: InfoContent(content, icon),
				footer: InfoFooter(action),
			});
		},
		[InfoContent, InfoFooter, t]
	);

	return { infoPopUpAction };
};
